import script from "./BirthdayCelebration.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayCelebration.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayCelebration.vue?vue&type=style&index=0&id=6fa55ffe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa55ffe"]])

export default __exports__